import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import Checkbox from "../../../../../shared/forms/Checkbox";
import useNewsletterStore from "./store";

const CheckboxRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-top: 20px;
`;

const Label = styled.div`
    flex-grow: 1;
`;

const Newsletter = () => {
    const [newsletterChecked, setNewsletterChecked] = useNewsletterStore(
        (state) => [state.newsletterChecked, state.setNewsletterChecked]
    );

    return (
        <React.Fragment>
            <CheckboxRow>
                <div>
                    <Checkbox
                        checked={newsletterChecked}
                        onClick={() => {
                            setNewsletterChecked(!newsletterChecked);
                        }}
                        css={css`
                            margin-top: 7px;
                            margin-right: 15px;
                        `}
                    />
                </div>
                <Label>
                    <span>
                        Ich stimme zu, dass die Wilhelm Hoyer B.V. & Co. KG mir
                        per E-Mail Newsletter mit Informationen über neue
                        Produkte, Veranstaltungen und Angebote von der Hoyer
                        Unternehmensgruppe zusendet und mich in den
                        Newsletter-Verteilerkreis aufnimmt. Zum Zweck des
                        Versands beauftragt die Wilhelm Hoyer B.V. & Co. KG
                        einen Dienstleister. Dort werden für die Dauer des
                        Versandes der elektronischen Informationen meine
                        Emailadresse und mein Name kurzfristig hochgeladen.
                    </span>
                </Label>
            </CheckboxRow>
        </React.Fragment>
    );
};

export default Newsletter;
